/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { TextAlignCenterIcon16Light } from './TextAlignCenterIcon16Light';
import { TextAlignCenterIcon16Regular } from './TextAlignCenterIcon16Regular';
import { TextAlignCenterIcon16Solid } from './TextAlignCenterIcon16Solid';
import { TextAlignCenterIcon20Light } from './TextAlignCenterIcon20Light';
import { TextAlignCenterIcon20Regular } from './TextAlignCenterIcon20Regular';
import { TextAlignCenterIcon20Solid } from './TextAlignCenterIcon20Solid';
import { TextAlignCenterIcon24Regular } from './TextAlignCenterIcon24Regular';
import { TextAlignCenterIcon24Solid } from './TextAlignCenterIcon24Solid';
import { TextAlignCenterIcon32Regular } from './TextAlignCenterIcon32Regular';
import { TextAlignCenterIcon64Regular } from './TextAlignCenterIcon64Regular';
var sizes = {
    16: {
        light: TextAlignCenterIcon16Light,
        regular: TextAlignCenterIcon16Regular,
        solid: TextAlignCenterIcon16Solid,
    },
    20: {
        light: TextAlignCenterIcon20Light,
        regular: TextAlignCenterIcon20Regular,
        solid: TextAlignCenterIcon20Solid,
    },
    24: {
        regular: TextAlignCenterIcon24Regular,
        solid: TextAlignCenterIcon24Solid,
    },
    32: {
        regular: TextAlignCenterIcon32Regular,
    },
    64: {
        regular: TextAlignCenterIcon64Regular,
    },
};
export var TextAlignCenterIcon = forwardRef('TextAlignCenterIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
